"use client"

import { cn } from "@/lib/utils"
import { Modal as MantineModal } from "@mantine/core"
import { Children } from "react"

import styles from "./dialog.module.scss"
import type { DialogProps } from "./types"

export function Dialog({
  opened,
  onClose,
  title,
  children,
  footer,
  bodyClassName,
  contentClassName,
  mantineBodyClassName,
  footerClassName,
  centered = true,
  withCloseButton = true,
  closeOnClickOutside = true,
  closeOnEscape = true,
  xOffset,
  yOffset,
  size = "md",
  fullScreen,
}: DialogProps) {
  return (
    <MantineModal
      opened={opened}
      onClose={onClose}
      title={title}
      centered={centered}
      withCloseButton={withCloseButton}
      closeOnClickOutside={closeOnClickOutside}
      closeOnEscape={closeOnEscape}
      xOffset={xOffset}
      yOffset={yOffset}
      size={size}
      fullScreen={fullScreen}
      padding={0}
      radius={0}
      transitionProps={{ transition: "fade", duration: 200 }}
      classNames={{
        content: cn(styles.content, contentClassName),
        body: cn(styles.mantineBody, mantineBodyClassName),
        header: styles.header,
        title: styles.title,
        close: styles.close,
      }}
    >
      <div className={cn(styles.body, bodyClassName)}>{children}</div>
      {footer ? (
        <div className={cn(styles.footer, footerClassName)}>
          {Children.toArray(footer).map((child, index) =>
            child ? (
              <div key={index} className={styles.footerAction}>
                {child}
              </div>
            ) : null
          )}
        </div>
      ) : null}
    </MantineModal>
  )
}

export type { DialogProps } from "./types"
